// import apiFetch from '../apiFetch'
export default function (token) {
  return {} // apiFetch({endPoint: 'notificationDossier', method: 'GET', body: null, token: token})
}
